export default __webpack_public_path__ + "static/media/Dashboard-success-icon.762ef427.png";